import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Play, LogIn } from 'lucide-react';

interface PreviewLoginWallProps {
  isVisible: boolean;
}

const PreviewLoginWall: React.FC<PreviewLoginWallProps> = ({ isVisible }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!isVisible) return null;

  return (
    <div className="absolute inset-0 z-30 flex items-center justify-center bg-black/85 backdrop-blur-sm">
      <div className="text-center max-w-md mx-4 p-8">
        <div className="w-20 h-20 bg-orange-600/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <Play className="w-10 h-10 text-orange-400" />
        </div>

        <h2 className="text-2xl font-bold text-white mb-3">
          Enjoying the preview?
        </h2>
        <p className="text-gray-300 mb-6">
          Sign in to continue watching and unlock all content on StrymHub.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/login', { state: { from: location } })}
            className="w-full px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors font-medium flex items-center justify-center space-x-2"
          >
            <LogIn className="w-5 h-5" />
            <span>Sign In to Continue</span>
          </button>
          <button
            onClick={() => navigate('/signup', { state: { from: location } })}
            className="w-full px-6 py-3 bg-gray-800 text-gray-300 rounded-lg hover:bg-gray-700 transition-colors font-medium"
          >
            Create Free Account
          </button>
        </div>

        <p className="text-gray-500 text-sm mt-4">
          It&apos;s free — sign up in seconds.
        </p>
      </div>
    </div>
  );
};

export default PreviewLoginWall;
